(function () {
	const initStoreSliders = () => {
		document.querySelectorAll('.store-slider-js').forEach((slider) => {
			if (slider.classList.contains('slider_started')) {
				return;
			}
			slider.classList.add('slider_started');
			
			const swiper = new Swiper(slider, {
				slidesPerView: 1,
				speed: 250,
				spaceBetween: 0,
				loop: true,
				navigation: {
					nextEl: slider.querySelector('.swiper-button-next-store'),
					prevEl: slider.querySelector('.swiper-button-prev-store'),
				},
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
			});
		});
	};

	// Initialize sliders on page load
	initStoreSliders();

	// Re-initialize on section load
	document.addEventListener('shopify:section:load', function () {
		initStoreSliders();
	});
})();
